<script lang="ts">
  import { loginUser } from '../../components/auth/LoginUser';
  import RepositoryFactory, { PAYINFO } from '../../repositories/RepositoryFactory';
  import { paytypeGroup } from '../../components/PayType';

  export let paytypeCode: string;

  const businessCode = $loginUser.businessCode;
  const contactUrlList = [
    { code: 'HIKARI_COLLABO', name: 'https://bb.unext.co.jp/contact' },
    { code: 'WITHUNET', name: 'https://bb.unext.co.jp/contact' },
    { code: 'UMOBILE_D', name: 'https://www.umobile.jp/inquiry' },
    { code: 'UMOBILE_D_ENECOM', name: 'https://www.umobile.jp/inquiry' },
    { code: 'UMOBILE_EA', name: 'https://www.umobile.jp/inquiry' },
    { code: 'UMOBILE_SONET', name: 'https://www.umobile.jp/inquiry' },
    { code: 'UMOBILE_PREMIUM', name: 'https://www.umobile.jp/inquiry' },
    { code: 'HIKARI_01', name: 'https://bb01.unext.co.jp/contact' }
  ];
  const contactUrl = contactUrlList.find((v) => v.code === businessCode).name;

  let payGroup: string;
  let urlParam = {
    MerchantId: '',
    EncryptValue: ''
  };
  let baseUrl: string;
  let disabledApply = true;

  (async () => {
    payGroup = paytypeGroup.find((v) => v.code === paytypeCode).name;

    //URLパラメータ暗号化
    const payinfoRepository = RepositoryFactory[PAYINFO];
    if (payGroup === 'CARD_UPDATE' || payGroup === 'CARD_NEW') {
      await payinfoRepository
        .getSlnEncrypt()
        .then((res) => {
          disabledApply = false;
          urlParam.MerchantId = res.merchantId;
          urlParam.EncryptValue = res.encrypt;
          baseUrl = res.slnUrl;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert('セッションが切れました。再度ログインしてください。');
            loginUser.logout();
            location.reload();
          } else {
            disabledApply = true;
            alert('エラーが発生しました。');
          }
        });
      // UMOBILE_Dで現在の支払方法がCARD以外の場合は支払方法を変更させない
    } else if (businessCode === 'UMOBILE_D' && paytypeCode !== 'CARD') {
      payGroup = 'NONE';
    }
  })();

  // 三者間画面遷移
  function showSlnChange() {
    document.location.href =
      baseUrl +
      '?' +
      Object.entries(urlParam)
        .map((e) => {
          let key = e[0];
          let value = e[1];
          return `${key}=${value}`;
        })
        .join('&');
  }
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">決済方法変更</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
    {#if payGroup === 'CARD_UPDATE' || payGroup === 'CARD_NEW'}
      <div class="grid grid-cols-2 justify-items-center items-center min-w-full p-2">
        <div class="col-start-1">
          <span class="form-label-title">クレジットカード情報変更</span>
        </div>
        <div class="col-start-2">
          <button on:click={showSlnChange} class="button-primary" disabled={disabledApply}>変更</button>
        </div>
      </div>
    {/if}
    {#if payGroup === 'NONE'}
      <div class="flex flex-col">
        <div class="flex-1">
          <div class="inline-grid grid-cols-1">
            <span class=""
              >お客さまの現在の支払方法では、マイページから変更ができません。<br />
              申し訳ございませんが、以下URLよりカスタマーセンターにご連絡ください。<br />

              URL：
              <a href={contactUrl} rel="noopener noreferrer" target="_blank">
                {contactUrl}
              </a></span
            >
          </div>
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
